export const mappingAutomationTypeWithName = {
  "abandoned-cart": "Abandoned Checkout",
  "just-abandoned-checkout": "Abandoned Checkout",
  "back-in-stock": "Back in Stock",
  "order-confirmation": "Order Confirmation",
  "order-tracking": "Order Tracking",
  "optin-confirmation": "Optin Confirmation",
  klaviyo: "Klaviyo webhook",
};
